import WebApi from './WebApi';

export class SalesOriginService {
  static async search(login) {
    const response = await WebApi.get(`/vendas?login=${login}`);

    return response.data;
  }
}
